import { Link } from '@remix-run/react';
import LogoImageMini from '~/core/ui/Logo/LogoImageMini';
import FaithGPTSVG from './FaithGPTSVG';

/**
 * LogoMini component.
 *
 * This component displays a mini version of the logo. It can be customized with several props.
 *
 * @param {Object} props - The properties that define the behavior of the LogoMini component.
 * @param {string} props.href - The URL that the logo will link to. Defaults to '/'.
 * @param {string} props.className - Additional CSS classes to apply to the component.
 * @param {boolean} props.showBeta - Whether to show the "BETA" label. Defaults to false.
 * @param {boolean} props.collapsed - Whether to collapse the logo. Defaults to false.
 * @param {boolean} props.textOnly - Whether to display only text, without the logo image. Defaults to false.
 * @param {Object} props.style - Additional CSS styles to apply to the component.
 *
 * @returns {React.Element} The LogoMini component.
 */
const LogoMini: React.FCC<{
  href?: string;
  className?: string;
  showBeta?: boolean;
  showSlash?: boolean;
  collapsed?: boolean;
  textOnly?: boolean;
  style?: React.CSSProperties;
}> = ({
  href,
  className = '',
  showBeta = false,
  showSlash = false,
  collapsed = false,
  textOnly = false,
  style,
}) => {
  return (
    <Link
      to={href ?? '/'}
      className={'flex w-fit items-center ml-[-5px] ' + className}
      style={{ ...style }}
    >
      {false && <LogoImageMini />}
      {!textOnly && <FaithGPTSVG />}
      {!collapsed && (
        <div
          className="flex flex-row items-center justify-center text-[1.5rem] relative"
          style={{
            fontFamily: "'Inter', sans-serif",
            textTransform: 'uppercase',
            fontWeight: '800 !important',
          }}
        >
          <span
            className={
              'font-black text-black dark:text-white tracking-[-1px] mr-0.5'
            }
          >
            Faith
          </span>
          {!collapsed && (
            <span className={'font-black text-secondary-500'}>GPT</span>
          )}
          {showBeta && (
            <div className="hidden md:flex text-[0.5rem] h-4 items-center border font-normal tracking-[1px] rounded mx-2 my-0 px-[0.35rem] py-1 border-solid">
              BETA
            </div>
          )}
        </div>
      )}
      {showSlash && (
        <span
          className={'text-4xl text-black dark:text-white'}
          style={{
            fontWeight: '100',
            fontFamily: "'Inter', sans-serif",
            display: 'block',
            transform: 'translate(0.5rem, -0.095rem)',
          }}
        >
          /
        </span>
      )}
    </Link>
  );
};

export default LogoMini;
